(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */

class CustomScripts {
  constructor() {
    this.init();
  }
  init() {
    /* Logo Marquee */
    $(window).on('load', function () {
      const $track = $('.logo-track');

      // Only run if .logo-track exists and has children
      if ($track.length && $track.children().length) {
        // Duplicate content
        const $clones = $track.children().clone();
        $track.append($clones);
        let pos = 0;
        const speed = 0.5; // px per frame (~30px/sec at 60fps)

        function animate() {
          pos -= speed;
          if (Math.abs(pos) >= $track[0].scrollWidth / 2) {
            pos = 0; // reset seamlessly
          }

          $track.css('transform', `translateX(${pos}px)`);
          requestAnimationFrame(animate);
        }
        animate();
      }
    });

    //Posts Slider Custom Arrows
    setTimeout(() => {
      var _window$bricksData;
      const mySlider = ((_window$bricksData = window.bricksData) === null || _window$bricksData === void 0 ? void 0 : _window$bricksData.splideInstances['zrgequ']) || false;
      const myPrevBtn = document.querySelector('.posts-slider--prev');
      const myNextBtn = document.querySelector('.posts-slider--next');
      if (mySlider && myPrevBtn && myNextBtn) {
        myPrevBtn.addEventListener('click', () => mySlider.go(-1));
        myNextBtn.addEventListener('click', () => mySlider.go(1));
      } else {
        console.warn('Slider or navigation buttons not found.');
      }
    }, 250);

    // Initialize component(s)

    $("body").on("click", "a.copy-link", function (e) {
      e.preventDefault();
      const href = $(this).attr("data-url");
      navigator.clipboard.writeText(href).then(() => {
        console.log("Copied:", href);
      }).catch(err => {
        console.error("Failed to copy:", err);
      });
    });
  }
}
var _default = CustomScripts;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Custom Dynamic Jump Menu (Table of Contents)
 * Requirements:
 * - A Content area with the class "js-jump-nav-sections"
 * - Each item in the ToCs should be it's own section
 * - A jump menu container with the class "js-jump-nav-menu"
 * - Jump menu should have link elements <a> equal to the number of sections in the content area (** This should be changed to be dynamic)
 */

class DyanmicTOC {
  constructor() {
    // Check if exists and initialize
    this.$dynamic_toc = $('.dynamic-toc');
    if (this.$dynamic_toc.length > 0) {
      this.init();
    }
    if (window.matchMedia("(max-width: 767px)").matches) {
      $(".dynamic-toc__contents").hide();
    }
    $(".dynamic-toc__title").click(function () {
      $(".dynamic-toc__contents").toggle(200);
      $(".toggle-icon i").toggleClass('ti-minus ti-plus');
    });
  }
  init() {
    // Initialize component(s)
    this.toc_contents = this.$dynamic_toc.find('.dynamic-toc__contents').get(0);
    this.$toc_title = this.$dynamic_toc.find('.dynamic-toc__title');
    this.content_selector = this.$dynamic_toc.data('content');
    this.headings_selector = this.$dynamic_toc.data('headings');
    this.$content = $(this.content_selector).first();
    this.$headings = this.$content.find(this.headings_selector);
    this.toc_array = new Array();
    if (!this.$content || !this.$headings) {
      console.log('Could not locate contents or headings...');
      return;
    }
    this.prepareHeadings();
    this.populateToc();
    this.observeElements();
  }
  prepareHeadings() {
    this.$headings.each((index, element) => {
      let element_text = this.replaceNbsps(element.textContent);
      let element_id = element_text.replace(/[^a-zA-Z0-9 ]/g, '').replaceAll(' ', '-').toLowerCase();
      element.id = element_id;
      let level = element.tagName.replace("H", "");
      let toc_item = {
        id: element_id,
        text: element_text,
        level: level
        //element: element,
      };

      this.toc_array.push(toc_item);
    });

    //console.log( this.toc_array );
  }

  replaceNbsps(str) {
    var re = new RegExp(String.fromCharCode(160), "g");
    return str.replace(re, " ");
  }
  populateToc() {
    if (this.toc_array.length == 0) {
      this.$dynamic_toc.addClass('d-none');
    } else {
      this.toc_contents.innerHTML = this.buildTree(this.toc_array);
      this.$toc_items = this.$dynamic_toc.find('.dynamic-toc__contents li');
    }
  }
  buildTree(headers) {
    //Code from: https://stackoverflow.com/questions/63218812/how-to-create-a-nested-list-elements-of-heading-tags-in-the-same-order-from-dom
    const list = [];
    let nextLevelHeaders = [];
    let lastLevel = -1;
    if (headers.length === 0) {
      return "";
    }
    const buildSubTree = () => {
      if (nextLevelHeaders.length > 0) {
        list[list.length - 1] += this.buildTree(nextLevelHeaders);
        //console.log(list);
      }
    };

    headers.forEach(h => {
      if (lastLevel !== -1 && lastLevel < h.level) {
        nextLevelHeaders.push(h);
        return;
      }
      buildSubTree();
      lastLevel = h.level;
      list.push(`<a class="toc__link" href="#${h.id}">${h.text}</a>`);
      nextLevelHeaders = [];
    });
    buildSubTree();
    const listHTML = list.map(i => `<li class="toc__item">${i}</li>`).join("");
    return `<ul class="toc__list">${listHTML}</ul>`;
  }
  observeElements() {
    this.sectionObserver = new IntersectionObserver((changes, observer) => {
      this.sectionIntersection(changes, observer);
    }, {
      rootMargin: "-80px 0px -80px 0px",
      threshold: 0
    });
    this.$headings.each((index, element) => {
      this.sectionObserver.observe(element);
    });
  }
  sectionIntersection(changes, observer) {
    changes.forEach(change => {
      let isIntersecting = change.isIntersecting;
      let target = change.target;
      if (isIntersecting) {
        let sectionId = target.getAttribute('id');
        let linkHref = "#" + sectionId;
        this.$toc_items.removeClass('active');
        this.$dynamic_toc.find('a[href="' + linkHref + '"]').closest('.toc__item').addClass('active');
      }
    });
  }
}
var _default = DyanmicTOC;
exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Custom Dynamic Jump Menu (Table of Contents)
 * Requirements:
 * - A Content area with the class "js-jump-nav-sections"
 * - Each item in the ToCs should be it's own section
 * - A jump menu container with the class "js-jump-nav-menu"
 * - Jump menu should have link elements <a> equal to the number of sections in the content area (** This should be changed to be dynamic)
 */

class JumpMenu {
  constructor() {
    // Check if exists and initialize
    this.$jump_nav_container = $('.js-jump-nav-content');
    this.$jump_nav_menu = $('.js-jump-nav-menu');
    if (this.$jump_nav_container.length > 0 && this.$jump_nav_menu.length > 0) {
      this.init();
    }
  }
  init() {
    // Initialize component(s)
    this.$jump_sections_container = $('.js-jump-nav-sections');
    if (this.$jump_nav_menu.length > 0 && this.$jump_sections_container.length > 0) {
      // Wire up events for sections and nav menu
      this.initializeLinks();
      this.identifyPageSections();
      this.observeElements();
    } else {
      console.log('Jump menu components missing. Could not initialize.');
    }
    this.$menuTitle = $('.jump-navigation__header__title');
    this.mobileTitle = this.$menuTitle.data('mobile-title');
    this.desktopTitle = this.$menuTitle.text();
    this.initMobile();
    let posOffset = 200;
    let jump_section_top_pos = this.$jump_sections_container.offset().top - posOffset;
    let jump_section_bottom_pos = this.$jump_sections_container.offset().top + this.$jump_sections_container.height() - posOffset - posOffset;
    // console.log('outer height: ' + jump_section_bottom_pos );
    this.$window = $(window);
    this.$window.scroll(() => {
      // console.log( 'scroll top: ' + this.$window.scrollTop() );

      if (this.$window.scrollTop() >= jump_section_top_pos && this.$window.scrollTop() < jump_section_bottom_pos) {
        this.$jump_nav_menu.addClass('visible');
      } else if (this.$window.scrollTop() < jump_section_top_pos || this.$window.scrollTop() >= jump_section_bottom_pos) {
        this.$jump_nav_menu.removeClass('visible');
      }
    });
  }
  initializeLinks() {
    this.$jump_links = this.$jump_nav_menu.find('a');
    this.$jump_links.each((index, element) => {
      let linkAnchorText = element.text.replace(/\s+/g, '');
      linkAnchorText = linkAnchorText.replace(/&+/g, '');
      element.setAttribute('href', '#' + linkAnchorText);
    });
  }
  identifyPageSections() {
    this.$sections = $('.js-jump-nav-sections > ');
    this.$sections.each((index, element) => {
      let sectionId = this.$jump_links[index].getAttribute('href').replace('#', "");
      element.setAttribute('data-section', index);
      element.setAttribute('id', sectionId);
      element.classList.add('js-jump-section');
    });
  }
  observeElements() {
    this.sectionObserver = new IntersectionObserver((changes, observer) => {
      this.sectionIntersection(changes, observer);
    }, {
      rootMargin: "-80px 0px -80px 0px",
      threshold: 0
    });
    this.$sections.each((index, element) => {
      this.sectionObserver.observe(element.firstChild);
    });
  }
  sectionIntersection(changes, observer) {
    changes.forEach(change => {
      let isIntersecting = change.isIntersecting;
      let target = change.target.parentNode;
      if (isIntersecting) {
        let sectionId = target.getAttribute('id');
        let linkHref = "#" + sectionId;
        this.$jump_links.removeClass('active');
        this.$jump_nav_menu.find('a[href="' + linkHref + '"]').addClass('active');
      }
    });
  }
  initMobile() {
    this.mediaQuery = window.matchMedia('(max-width: 991px)');
    this.mediaQuery.addEventListener('change', e => {
      this.responsiveHandler(e);
    });
    if (this.mediaQuery.matches) {
      this.$jump_nav_menu.addClass('collapse');
      this.displayMobileTitle();
    } else {
      this.displayDesktopTitle();
    }
    this.$jump_nav_menu.on('click', () => {
      this.$jump_nav_menu.toggleClass('open');
    });
    this.mobileCloseBtn = $('.jump-navigation__exit-button');
    this.mobileCloseBtn.on('click', e => {
      this.$jump_nav_menu.toggleClass('open');
      e.stopPropagation();
    });
  }
  responsiveHandler(e) {
    if (this.mediaQuery.matches) {
      this.$jump_nav_menu.addClass('collapse');
      this.displayMobileTitle();
    } else {
      this.$jump_nav_menu.removeClass('collapse');
      this.$jump_nav_menu.removeClass('open');
      this.displayDesktopTitle();
    }
  }
  displayMobileTitle() {
    this.$menuTitle.text(this.mobileTitle);
  }
  displayDesktopTitle() {
    this.$menuTitle.text(this.desktopTitle);
  }
}
var _default = JumpMenu;
exports.default = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class StickyHeader {
  constructor() {
    const header = document.getElementById("brx-header");
    const topRow = document.querySelector(".pro-header-1__top-row");
    const mobileMenu = document.querySelector(".bricks-mobile-menu-wrapper");
    const toggleBtn = document.querySelector(".bricks-mobile-menu-toggle");
    if (!header || !topRow) return;

    // 1. Setup CSS Variable
    const setTopRowHeight = () => {
      document.documentElement.style.setProperty('--top-row-height', topRow.offsetHeight + 'px');
    };
    setTopRowHeight();
    window.addEventListener('resize', setTopRowHeight);
    let lastScroll = 0;

    // 2. The Scroll Logic
    const handleScroll = () => {
      // CHECK: Is our override class active?
      if (header.classList.contains('menu-open-override')) {
        return; // STOP. Do not run any logic.
      }

      const currentScroll = window.scrollY;
      if (currentScroll < 0) return; // Safari fix

      if (currentScroll > lastScroll && currentScroll > 50) {
        header.classList.add('hide-top-bar');
      } else {
        header.classList.remove('hide-top-bar');
      }
      lastScroll = currentScroll;
    };

    // 3. The "Kill Switch" Function
    const toggleMenuState = isOpen => {
      if (isOpen) {
        // MENU OPENED: Add override, remove hidden state
        header.classList.add('menu-open-override');
        header.classList.remove('hide-top-bar');
      } else {
        // MENU CLOSED: Remove override, resume scroll logic
        header.classList.remove('menu-open-override');
      }
    };

    // 4. LISTENERS

    // A. Scroll Listener
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });

    // B. Button Click Listener (Immediate Reaction)
    if (toggleBtn) {
      toggleBtn.addEventListener('click', () => {
        // We check if it WAS expanded before the click processed
        const isExpanding = toggleBtn.getAttribute('aria-expanded') === 'false';
        toggleMenuState(isExpanding);
      });
    }

    // C. MutationObserver (Backup Safety)
    if (mobileMenu) {
      const observer = new MutationObserver(() => {
        const isOpen = mobileMenu.classList.contains('brx-open');
        toggleMenuState(isOpen);
      });
      observer.observe(mobileMenu, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }
}
var _default = StickyHeader;
exports.default = _default;

},{}],5:[function(require,module,exports){
"use strict";

var _customScripts = _interopRequireDefault(require("./modules/custom-scripts"));
var _dynamicToc = _interopRequireDefault(require("./modules/dynamic-toc"));
var _jumpMenu = _interopRequireDefault(require("./modules/jump-menu"));
var _stickyHeader = _interopRequireDefault(require("./modules/sticky-header"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

window.$ = jQuery;
// import SocialSharePopups from './modules/social-share-popups';

$(document).ready(function () {
  $('html').addClass('js-on-load');

  // const backToTop = new BackToTop();
  const jumpMenu = new _jumpMenu.default();
  // const socialSharePopups = new SocialSharePopups();

  // plugin('ResponsiveTabs', ResponsiveTabs);

  const customScripts = new _customScripts.default();
  const dynamicTOC = new _dynamicToc.default();
  const stickyHeader = new _stickyHeader.default();

  // Initialize Case Evaluation text link triggers (#case-evaluation)
  initBricksPopupLinks();
});
function initBricksPopupLinks() {
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href]');
    if (!link) return;
    let hash;
    try {
      hash = new URL(link.href).hash;
    } catch (err) {
      return;
    }
    if (!hash) return;
    if (hash !== "#case-evaluation") return;
    e.preventDefault();
    bricksOpenPopup(16822);
  });
}

},{"./modules/custom-scripts":1,"./modules/dynamic-toc":2,"./modules/jump-menu":3,"./modules/sticky-header":4}]},{},[5]);
